<template>
  <div class="publications-artists__pagination" v-if="worksTotal>maxWorksOnPage">
    <a v-on:click="prevPage(false, $event)">
      <img class="publications-artists__nav--prev" src="/res/subdomains/img/favorites-work__arrow--left.svg" alt="arrow"/>
    </a>

    <ul id="id_pager" class="publications-artists__list" style="overflow: hidden; white-space: nowrap;">
      <template v-if="snowFirst">
        <li>
          <a v-on:click="changePage(1, false, $event)" class="pointer">
            1
          </a>
        </li>
        <li><a>...</a></li>
      </template>

      <li v-for="page in range">
        <a v-on:click="changePage(page, false, $event)" class="pointer" :class="{ active: page == currentPage  }">
          {{ page }}
        </a>
      </li>
    </ul>

    <a v-on:click="nextPage(false, $event)">
      <img class="publications-artists__nav--next" src="/res/subdomains/img/favorites-work__arrow--left.svg" alt="arrow"/>
    </a>
  </div>
</template>

<script>
  import WorksPaginationMix from '../../../../components/list/WorksPaginationMix';

  export default {
    name    : 'works-pagination-sub',
    mixins: [WorksPaginationMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_dark/components/list/WorksPaginationSub.vue